var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'simple-message-list-container': true,
      'simple-message-list-container-mobile': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('span', {
    staticClass: "back",
    on: {
      "click": _vm.backPreviousLevel
    }
  }, [_c('Icon', {
    staticClass: "close-icon",
    attrs: {
      "file": _vm.addIcon,
      "size": '18px'
    }
  }), _vm.isReturn ? _c('span', [_vm._v(_vm._s(_vm.TUITranslateService.t("TUIChat.返回")))]) : _c('span', [_vm._v(_vm._s(_vm.TUITranslateService.t("TUIChat.关闭")))])], 1), _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.currentMergeMessageInfo.title) + " ")])]), _vm.isDownloadOccurError ? _c('div', [_vm._v(" Load Merge Message Error ")]) : _vm.isMergeMessageInfoLoaded ? _c('div', {
    ref: "simpleMessageListRef",
    staticClass: "message-list"
  }, _vm._l(_vm.currentMergeMessageInfo.messageList, function (item) {
    return _c('div', {
      key: item.ID,
      class: {
        'message-item': true
      }
    }, [_c('MessageContainer', {
      attrs: {
        "sender": item.nick,
        "avatar": item.avatar,
        "type": item.messageBody[0].type,
        "time": item.time
      }
    }, [item.messageBody[0].type === _vm.TYPES.MSG_TEXT ? _c('div', {
      staticClass: "message-text"
    }, _vm._l(_vm.parseTextToRenderArray(item.messageBody[0].payload['text']), function (textInfo, index) {
      return _c('span', {
        key: index,
        staticClass: "message-text-container"
      }, [textInfo.type === 'text' ? _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(textInfo.content))]) : _c('img', {
        staticClass: "simple-emoji",
        attrs: {
          "src": textInfo.content,
          "alt": "small-face"
        }
      })]);
    }), 0) : item.messageBody[0].type === _vm.TYPES.MSG_IMAGE ? _c('div', {
      staticClass: "message-image"
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": item.messageBody[0].payload['imageInfoArray'][2]['url'],
        "mode": "widthFix",
        "alt": "image"
      }
    })]) : item.messageBody[0].type === _vm.TYPES.MSG_VIDEO ? _c('div', {
      staticClass: "message-video"
    }, [_c('video', {
      staticClass: "video",
      attrs: {
        "controls": "",
        "poster": item.messageBody[0].payload['thumbUrl']
      }
    }, [_c('source', {
      attrs: {
        "src": item.messageBody[0].payload['remoteVideoUrl'],
        "type": "video/mp4"
      }
    })])]) : item.messageBody[0].type === _vm.TYPES.MSG_AUDIO ? _c('div', {
      staticClass: "message-audio"
    }, [_c('span', [_vm._v(_vm._s(_vm.TUITranslateService.t("TUIChat.语音")) + " ")]), _c('span', [_vm._v(_vm._s(item.messageBody[0].payload.second) + "s")])]) : item.messageBody[0].type === _vm.TYPES.MSG_FACE ? _c('div', {
      staticClass: "message-face"
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.resolveBigFaceUrl(item.messageBody[0].payload.data),
        "alt": "face"
      }
    })]) : item.messageBody[0].type === _vm.TYPES.MSG_FILE ? _c('div', {
      staticClass: "message-file"
    }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.[文件]")) + " ")]) : item.messageBody[0].type === _vm.TYPES.MSG_LOCATION ? _c('div', [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.[地理位置]")) + " ")]) : item.messageBody[0].type === _vm.TYPES.MSG_MERGER ? _c('div', {
      staticClass: "message-merger",
      on: {
        "!click": function ($event) {
          return _vm.entryNextLevel($event, item);
        }
      }
    }, [_c('MessageRecord', {
      attrs: {
        "disabled": "",
        "renderData": item.messageBody[0].payload
      }
    })], 1) : item.messageBody[0].type === _vm.TYPES.MSG_CUSTOM ? _c('div', [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.[自定义消息]")) + " ")]) : _vm._e()])], 1);
  }), 0) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }